import router from "@/router";
import { getStorage, getToken, removeToken } from '@/utils';

const whiteList = ['/', '/redirect', '/home', '/production', '/signInUp/countryChange','/application/result/waiting','/application/result/error', '/authorization', '/signInUp', '/signInUp/pin', '/signInUp/code', '/signInUp/setPin', '/signInUp/provacyPolicy', '/signInUp/termsOfUse']

router.beforeEach((to, from, next) => {
    window?.Android?.setSystemBackground(to.meta.statusbarColor ? to.meta.statusbarColor : '#FFFFFF')
    console.log('--------------------检查H5版本------------------------');

    window?.Android?.checkVersion();
    // 获取设备信息
    const deviceInfo = getStorage('device-info') ? JSON.parse(getStorage('device-info')) : null;

    const token = getToken() || null;
    if (whiteList.indexOf(to.path) === -1) {
        console.log(JSON.stringify(deviceInfo));
        if (!token || !deviceInfo || !deviceInfo.phone) {
            removeToken()
            setTimeout(() => {
                next('/');
            }, 100);
        } else {
            next();
        }
    } else {
        next();
    }
});
